export const certifications = [
  {
    id: 1,
    name: 'AWS Certified Solutions Architect - Associate',
    issuer: 'Amazon Web Services (AWS)',
    date: 'Feb 2020',
    expiryDate: 'Feb 2023',
    credentialId: '7B5M23D2HNVYIQ951',
    logo: '/certs/aws-sa-pro.svg',
    verificationUrl: 'https://aws.amazon.com/verification',
    skills: ['Cloud Architecture', 'AWS Services', 'Solutions Design'],
    description: 'Certification validating expertise in designing distributed systems on AWS',
    expired: true
  },
  {
    id: 2,
    name: 'AWS Certified Cloud Practitioner',
    issuer: 'Amazon Web Services (AWS)',
    date: 'Jun 2019',
    expiryDate: 'Jun 2022',
    credentialId: '87H6J7N2JE44QLKE',
    logo: '/certs/aws-sa-pro.svg',
    verificationUrl: 'https://aws.amazon.com/verification',
    skills: ['Cloud Fundamentals', 'AWS Core Services', 'Cloud Concepts'],
    description: 'Foundational certification demonstrating understanding of AWS Cloud',
    expired: true
  }
]

export const getActiveCertifications = () => {
  return certifications
}

export const getCertificationsByIssuer = (issuer) => {
  return certifications.filter(cert => cert.issuer === issuer)
}

export const getAWSCertifications = () => {
  return getCertificationsByIssuer('Amazon Web Services')
}